import type {AppHomepageTile} from './app-homepage-tile';
import type {CodeEnvModel} from './../code/code-env-model';
import type {GeneralSettingsDAO} from './../dao/general-settings-dao';
import type {ProjectExportOptions} from './../projects/importexport/model/project-export-options';

/**
 * Generated from com.dataiku.dip.coremodel.AppManifest
 */
export interface AppManifest {
    accessRequestsEnabled: GeneralSettingsDAO.InheritableEnabledSetting.LocalValue;
    allowedMissingCodeEnvs: CodeEnvModel.UsedCodeEnvRef[];
    allowedMissingConnections: string[];
    description: string;
    homepageSections: AppManifest.AppHomepageSection[];
    id: string;
    imgColor: string;
    imgPattern: number;
    instanceFeatures: AppManifest.AppInstancesFeatures;
    instantiationPermission: AppManifest.AppInstantiationPermission;
    label: string;
    limitedVisibilityEnabled: GeneralSettingsDAO.InheritableEnabledSetting.LocalValue;
    projectExportManifest: AppManifest.AppProjectExportManifest;
    shortDesc: string;
    showInitials: boolean;
    tags: string[];
    useAppHomepage: boolean;
    useAsRecipeSettings: AppManifest.AppUseAsRecipeSettings;
}

export namespace AppManifest {
    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppInstancesFeatures
     */
    export interface AppInstancesFeatures {
        showCodeNavLink: boolean;
        showFlowNavLink: boolean;
        showLabNavLink: boolean;
        showSwitchToProjectViewButton: boolean;
        showVersionControlFeatures: boolean;
    }

    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppInstantiationPermission
     */
    export enum AppInstantiationPermission {
        EVERYBODY = 'EVERYBODY',
        USE_APP_MASTER_PERMISSIONS = 'USE_APP_MASTER_PERMISSIONS'
    }

    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppHomepageSection
     */
    export interface AppHomepageSection {
        sectionText: string;
        sectionTitle: string;
        tiles: AppHomepageTile[];
    }

    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppProjectExportManifest
     */
    export interface AppProjectExportManifest {
        exportAllDatasets: boolean;
        exportAllInputDatasets: boolean;
        exportAllInputManagedFolders: boolean;
        exportAnalysisModels: boolean;
        exportGitRepository: boolean;
        exportInsightsData: boolean;
        exportLabelingTasks: boolean;
        exportManagedFS: boolean;
        exportManagedFolders: boolean;
        exportModelEvaluationStores: boolean;
        exportProjectResources: boolean;
        exportSavedModels: boolean;
        exportUploads: boolean;
        includedCodeStudios: ProjectExportOptions.IncludedCodeStudio[];
        includedDatasetsData: ProjectExportOptions.IncludedDatasetData[];
        includedLabelingTasks: ProjectExportOptions.IncludedLabelingTask[];
        includedManagedFolders: ProjectExportOptions.IncludedManagedFolder[];
        includedModelEvaluationStores: ProjectExportOptions.IncludedModelEvaluationStore[];
        includedSavedModels: ProjectExportOptions.IncludedSavedModel[];
    }

    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppUseAsRecipeSettings
     */
    export interface AppUseAsRecipeSettings {
        category: string;
        icon: string;
        inputRoles: AppManifest.AppUseAsRecipeSettings.RoleMapping[];
        outputRoles: AppManifest.AppUseAsRecipeSettings.RoleMapping[];
        runScenarioTile: AppHomepageTile.RunScenarioTile;
        variablesEditionTile: AppHomepageTile.ProjectVariablesTile;
    }
}

export namespace AppManifest.AppUseAsRecipeSettings {
    /**
     * Generated from com.dataiku.dip.coremodel.AppManifest$AppUseAsRecipeSettings$RoleMapping
     */
    export interface RoleMapping {
        objectId: string;
        roleLabel: string;
        type: any /* TODO: Missing translation of com.dataiku.dip.dataflow.graph.FlowComputable$FCType */;
    }
}